var _findNodeHandle = require('./modules/findNodeHandle');

var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);

var _ReactDefaultInjection = require('react/lib/ReactDefaultInjection');

var _ReactDefaultInjection2 = _interopRequireDefault(_ReactDefaultInjection);

var _ReactMount = require('react/lib/ReactMount');

var _Animated = require('./apis/Animated');

var _Animated2 = _interopRequireDefault(_Animated);

var _AppRegistry = require('./apis/AppRegistry');

var _AppRegistry2 = _interopRequireDefault(_AppRegistry);

var _AppState = require('./apis/AppState');

var _AppState2 = _interopRequireDefault(_AppState);

var _AsyncStorage = require('./apis/AsyncStorage');

var _AsyncStorage2 = _interopRequireDefault(_AsyncStorage);

var _Clipboard = require('./apis/Clipboard');

var _Clipboard2 = _interopRequireDefault(_Clipboard);

var _Dimensions = require('./apis/Dimensions');

var _Dimensions2 = _interopRequireDefault(_Dimensions);

var _Easing = require('animated/lib/Easing');

var _Easing2 = _interopRequireDefault(_Easing);

var _I18nManager = require('./apis/I18nManager');

var _I18nManager2 = _interopRequireDefault(_I18nManager);

var _InteractionManager = require('./apis/InteractionManager');

var _InteractionManager2 = _interopRequireDefault(_InteractionManager);

var _Linking = require('./apis/Linking');

var _Linking2 = _interopRequireDefault(_Linking);

var _NetInfo = require('./apis/NetInfo');

var _NetInfo2 = _interopRequireDefault(_NetInfo);

var _PanResponder = require('./apis/PanResponder');

var _PanResponder2 = _interopRequireDefault(_PanResponder);

var _PixelRatio = require('./apis/PixelRatio');

var _PixelRatio2 = _interopRequireDefault(_PixelRatio);

var _Platform = require('./apis/Platform');

var _Platform2 = _interopRequireDefault(_Platform);

var _StyleSheet = require('./apis/StyleSheet');

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _UIManager = require('./apis/UIManager');

var _UIManager2 = _interopRequireDefault(_UIManager);

var _Vibration = require('./apis/Vibration');

var _Vibration2 = _interopRequireDefault(_Vibration);

var _ActivityIndicator = require('./components/ActivityIndicator');

var _ActivityIndicator2 = _interopRequireDefault(_ActivityIndicator);

var _Button = require('./components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Image = require('./components/Image');

var _Image2 = _interopRequireDefault(_Image);

var _ListView = require('./components/ListView');

var _ListView2 = _interopRequireDefault(_ListView);

var _ProgressBar = require('./components/ProgressBar');

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _ScrollView = require('./components/ScrollView');

var _ScrollView2 = _interopRequireDefault(_ScrollView);

var _Switch = require('./components/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _Text = require('./components/Text');

var _Text2 = _interopRequireDefault(_Text);

var _TextInput = require('./components/TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Touchable = require('./components/Touchable/Touchable');

var _Touchable2 = _interopRequireDefault(_Touchable);

var _TouchableHighlight = require('./components/Touchable/TouchableHighlight');

var _TouchableHighlight2 = _interopRequireDefault(_TouchableHighlight);

var _TouchableOpacity = require('./components/Touchable/TouchableOpacity');

var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);

var _TouchableWithoutFeedback = require('./components/Touchable/TouchableWithoutFeedback');

var _TouchableWithoutFeedback2 = _interopRequireDefault(_TouchableWithoutFeedback);

var _View = require('./components/View');

var _View2 = _interopRequireDefault(_View);

var _createDOMElement = require('./modules/createDOMElement');

var _createDOMElement2 = _interopRequireDefault(_createDOMElement);

var _NativeModules = require('./modules/NativeModules');

var _NativeModules2 = _interopRequireDefault(_NativeModules);

var _ColorPropType = require('./propTypes/ColorPropType');

var _ColorPropType2 = _interopRequireDefault(_ColorPropType);

var _EdgeInsetsPropType = require('./propTypes/EdgeInsetsPropType');

var _EdgeInsetsPropType2 = _interopRequireDefault(_EdgeInsetsPropType);

var _PointPropType = require('./propTypes/PointPropType');

var _PointPropType2 = _interopRequireDefault(_PointPropType);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

_ReactDefaultInjection2.default.inject();

var ReactNative = {
  findNodeHandle: _findNodeHandle2.default,
  render: _ReactMount.render,
  unmountComponentAtNode: _ReactMount.unmountComponentAtNode,
  Animated: _Animated2.default,
  AppRegistry: _AppRegistry2.default,
  AppState: _AppState2.default,
  AsyncStorage: _AsyncStorage2.default,
  Clipboard: _Clipboard2.default,
  Dimensions: _Dimensions2.default,
  Easing: _Easing2.default,
  I18nManager: _I18nManager2.default,
  InteractionManager: _InteractionManager2.default,
  Linking: _Linking2.default,
  NetInfo: _NetInfo2.default,
  PanResponder: _PanResponder2.default,
  PixelRatio: _PixelRatio2.default,
  Platform: _Platform2.default,
  StyleSheet: _StyleSheet2.default,
  UIManager: _UIManager2.default,
  Vibration: _Vibration2.default,
  ActivityIndicator: _ActivityIndicator2.default,
  Button: _Button2.default,
  Image: _Image2.default,
  ListView: _ListView2.default,
  ProgressBar: _ProgressBar2.default,
  ScrollView: _ScrollView2.default,
  Switch: _Switch2.default,
  Text: _Text2.default,
  TextInput: _TextInput2.default,
  Touchable: _Touchable2.default,
  TouchableHighlight: _TouchableHighlight2.default,
  TouchableOpacity: _TouchableOpacity2.default,
  TouchableWithoutFeedback: _TouchableWithoutFeedback2.default,
  View: _View2.default,
  createDOMElement: _createDOMElement2.default,
  NativeModules: _NativeModules2.default,
  ColorPropType: _ColorPropType2.default,
  EdgeInsetsPropType: _EdgeInsetsPropType2.default,
  PointPropType: _PointPropType2.default
};
module.exports = ReactNative;